export default "__VITE_ASSET__bc936669__"